import withErrorBoundary from 'components/HOC/ErrorBoundryHOC';
import { connect } from 'react-redux';
import { setHasNoData } from 'state/actions';
import {
  DateSelectionChanged,
  getCommitStats,
  getContributors,
  getJobDetails,
  getTeams,
  toggleModal,
  toggleSnackBar,
  updateTeam,
  updateTeamContributors
} from 'state/callers';
import { patchAccount } from 'state/callers/account';
import { createTeam } from 'state/callers/teams';
import { myAccountSelector } from 'state/selectors/account';
import { contributorsBarsSelector } from 'state/selectors/commit-stats';
import { individualContributorsSelector } from 'state/selectors/contributors';
import {
  current5IterationsSelector,
  currentIterationSelector,
  datesFromTheBeginningOfPrevIterSelector,
  numOfDaysInLatestIterationSelector,
  getLatestIterationSelector,
  isRetrospectSelector,
  nonComputedIterationsSelector
} from 'state/selectors/iterations-picker';
import { isSyncContributorsJobFinishedSelector } from 'state/selectors/jobs';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { isFinishedOnBoardingSelector } from 'state/selectors/organization';
import { repositoriesByIdSelector } from 'state/selectors/repositories';

import {
  isProjectManagementConnectedSelector,
  getSlackSensorAuthorizationSelector,
  pmIntegrationSelector
} from 'state/selectors/sensors-authorizations';
import {
  selectedTeamProject,
  selectedTeamContainerIds
} from 'state/selectors/projects';
import { teamsWithExtraSyncedDataSelector } from 'state/selectors/teams';
import {
  actualIterationEndDate,
  hasNoDataSelector,
  isBlurredSelector,
  isProcessingReposSelector,
  isVPModeSelector,
  numOfDaysInIterationSelector,
  selectedTeamSelector
} from 'state/selectors/ui-state';
import Dashboard from './Dashboard';

const mapStateToProps = state => {
  const { uiState, organization, showLoader } = state;
  return {
    selectedTeam: selectedTeamSelector(state),
    contributorsBars: contributorsBarsSelector(state),
    current5Iterations: current5IterationsSelector(state),
    contributors: individualContributorsSelector(state),
    currentTeams: teamsWithExtraSyncedDataSelector(state),
    uiState,
    repositoriesById: repositoriesByIdSelector(state),
    organization,
    isFinishedOnBoarding: isFinishedOnBoardingSelector(state),
    account: myAccountSelector(state),
    iterations: nonComputedIterationsSelector(state),
    currentIteration: currentIterationSelector(state),
    datesFromTheBeginningOfPrevIter:
      datesFromTheBeginningOfPrevIterSelector(state),
    isRetrospect: isRetrospectSelector(state),
    actualIterationEndDate: actualIterationEndDate(state),
    numOfDaysInSelectedIteration: numOfDaysInIterationSelector(state),
    numOfDaysInLatestIteration: numOfDaysInLatestIterationSelector(state),
    isVPMode: isVPModeSelector(state),
    slackSensorAuhorization: getSlackSensorAuthorizationSelector(state),
    myAccount: myAccountSelector(state),
    isSyncContributorsCompleted: isSyncContributorsJobFinishedSelector(state),
    isJiraConnected: isProjectManagementConnectedSelector(state),
    latestIteration: getLatestIterationSelector(state),
    isTeamLicense: isTeamLicenseSelector(state),
    isProcessingRepos: isProcessingReposSelector(state),
    isBlurred: isBlurredSelector(state),
    hasNoData: hasNoDataSelector(state),
    selectedTeamProject: selectedTeamProject(state),
    teamPMEntitiesIds: selectedTeamContainerIds(state),
    pmSensor: pmIntegrationSelector(state),
    showLoader
  };
};

const mapDispatchToProps = {
  toggleModal,
  DateSelectionChanged,
  getCommitStats,
  createTeam,
  toggleSnackBar,
  patchAccount,
  updateTeam,
  updateTeamContributors,
  getTeams,
  getContributors,
  getJobDetails,
  setHasNoData
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withErrorBoundary(Dashboard, 'Dashboard'));
